import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets
import i18n from "./lang";
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'
import '@flaticon/flaticon-uicons/css/solid/rounded.css'
import '@flaticon/flaticon-uicons/css/solid/straight.css'
import '@flaticon/flaticon-uicons/css/regular/rounded.css'
import '@flaticon/flaticon-uicons/css/regular/straight.css'
import '@flaticon/flaticon-uicons/css/bold/rounded.css'
import '@flaticon/flaticon-uicons/css/bold/straight.css'

import "@/assets/font-Roboto/font.css"
import "@/assets/font-TikTok/font.css"
import '@/styles/index.scss' // global css
import '@flaticon/flaticon-uicons/css/regular/straight.css' // fi图标库

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission' // permission control
import directive from './directive' //directive


import 'element-ui/lib/theme-chalk/base.css';
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
import loading from "@/components/loading/loading.vue";
import hurixPagination from "@/components/hurixPagination"
import HurixEmpty from "@/components/HurixEmpty";

Vue.component('el-collapse-transition', CollapseTransition)
Vue.component('loading', loading)
Vue.component('hurixPagination', hurixPagination)
Vue.component('HurixEmpty', HurixEmpty)


import {installFilters} from './filters'

// 安装所有过滤器
installFilters(Vue)

// 分页组件 全局挂载
import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)

import WebIM from './IM/webIM.js';  // 环信客服聊天
Vue.prototype.$webIM = WebIM;
const EventBus = new Vue()
Vue.prototype.$eventBus = EventBus
Vue.prototype.$webIM.conn.addEventHandler("eventName", {
  //当前用户收到图片消息。
  onImageMessage: function (message) {
    EventBus.$emit('new-im-message', message)
    EventBus.$emit('im-get-num', message)
  },
  // 当前用户收到文字消息。
  onTextMessage: function (message) {
    EventBus.$emit('new-im-message', message)
    EventBus.$emit('im-get-num', message)
  },
  onReceivedMessage: function (message) { // 收到消息送达服务器回执
    EventBus.$emit('im-onReceivedMessage', message)
  },
});

import Decimal from 'decimal.js'  // 精度计算
Vue.prototype.$decimal = Decimal;
import {getPriceToLocale} from "./views/oms/order/common"

Vue.prototype.$getPriceToLocale = getPriceToLocale;

// stripe
import { loadStripe } from '@stripe/stripe-js';
let stripePK = process.env.NODE_ENV === 'production' ?
  'pk_live_51SI3fMIc5bwtPu2xzWoRyGjVMPcBnaOaWmEvNEfT9qp8dwkoeBnNDCxZFv62cwYutsfKdd70hyzNcoXdEPMrzRD900CcalBgSt' :
  'pk_test_51SI3fMIc5bwtPu2xvdM4vF41v6HwZliZ4uzFmQkgDJwZ99rCEbRBOzmnCdmikWPKTqDVD1UivQ8X4eIAHfMazgvG00pPzOpZeI'

loadStripe(stripePK).then(stripe => {
  Vue.prototype.$stripe = stripe
}).catch(err=> {
})

import {formatTimestamp} from '@/utils/index'
import { getDatePart, getTimePart } from '@/utils/dateParts'

Vue.prototype.$formatTimestamp = formatTimestamp;
Vue.mixin({ methods: { getDatePart, getTimePart } });

Vue.prototype.$fileDomain = process.env.NODE_ENV === 'production' ? 'https://file.hurix.shop/' : 'https://file.hurix.cc/'
Vue.prototype.$termUrl = process.env.NODE_ENV === "production" ? 'https://hurix.shop/#/' : 'https://hurix.cc/web/#/'

Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)// 在注册Element时设置i18n的处理方法
})
Vue.use(ElementUI, {locale})
Vue.use(VCharts)
Vue.use(directive)
import VueGtag from 'vue-gtag';
Vue.use(VueGtag, {
  config: {
    id: process.env.NODE_ENV === 'production' ? 'G-DVJPLEYRKJ' : 'G-RVJFJSTVTC', // 例如: 'G-XXXXXXXXXX'
  },
}, router) // 传入 router 实例，插件会自动跟踪页面浏览

import customConfirm from '@/utils/confirm'
Vue.prototype.$confirm = customConfirm

Vue.config.productionTip = false
const initApp = async () => {
  const {country} = await store.dispatch('GetLocalIP')
  const isCN = country === 'CN'
  if (!localStorage.getItem('language-seller')) {
    i18n.locale = isCN ? 'zh' : 'en';
    localStorage.setItem('language-seller', isCN ? 'zh' : 'en');
  }

  new Vue({
    el: '#app',
    i18n,
    router,
    store,
    template: '<App/>',
    components: {App}
  })

  Vue.prototype.$timeFormat = (showTime = true) => {
    if (showTime) return isCN ? 'yyyy-MM-dd HH:mm:ss' : 'dd-MM-yyyy HH:mm:ss'
    return isCN ? 'yyyy-MM-dd' : 'dd-MM-yyyy'
  }
}


initApp()



// WEBPACK FOOTER //
// ./src/main.js